import { motion } from "framer-motion";
import { ChapterHeader } from "./ChapterHeader";

const CHAPTERS = [
  {
    n: "01",
    title: "Since 2014",
    body: "Twelve years of stamping passports, planning honeymoons and rescuing last-minute itineraries. Old enough to know every embassy queue, young enough to answer WhatsApp at midnight.",
  },
  {
    n: "02",
    title: "1000+ visa approvals",
    body: "Tourist, work and business visas with documentation done right the first time. Our checklists are built from a decade of real approvals — and a few hard lessons.",
  },
  {
    n: "03",
    title: "One WhatsApp away",
    body: "No call centres, no ticket numbers, no hold music. You talk directly to the people planning your trip — before, during and after you fly.",
  },
];

export const WhyUsSection = () => (
  <section id="why-us" data-testid="why-us-section" className="relative bg-ink px-6 py-28 md:px-10 md:py-36">
    <div className="mx-auto max-w-7xl">
      <ChapterHeader
        index="03"
        title="Why Gautam Travel"
        testid="why-us-header"
        heading={
          <>
            A small agency with a <span className="italic text-sunset">big reputation.</span>
          </>
        }
      />

      <div className="divide-y divide-white/10 border-y border-white/10">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.1 }}
            data-testid={`why-us-chapter-${c.n}`}
            className="grid items-start gap-6 py-12 md:grid-cols-12 md:py-16"
          >
            <span
              className="font-display text-7xl leading-none text-transparent md:col-span-3 md:text-8xl"
              style={{ WebkitTextStroke: "1px rgba(255,107,53,0.6)" }}
            >
              {c.n}
            </span>
            <h3 className="font-display text-3xl md:col-span-4 md:text-4xl">{c.title}</h3>
            <p className="max-w-md text-base font-light leading-relaxed text-white/60 md:col-span-5">{c.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
